import {
  convocatoria001,
  n1,
  n2,
  convocatoriaLOP1,
  lop1,
  convocatoria002,
  n3,
  n4,
  n5,
  n6,
  n7,
  convocatoria003,
  n8,
  n9,
  convocatoria004,
  n10,
  convocatoria005,
  n11,
  n12,
  n13,
  n14,
  convocatoriaLOP2,
  lop2,
  convocatoriaLOP3,
  lop3,
  convocatoria006,
  n15,
  n16,
  n17,
  n18,
  convocatoriaLOP4,
  lop4,
  convocatoria007,
  n19,
  n20,
  n21,
  convocatoria008,
  n22,
  n23,
  n24,
  convocatoriaMult05,
  lop5,
  lop6,
  convocatoria009,
  n25,
  convocatoria010,
  n26,
  convocatoria011,
  n27,
  n28,
  n29,
  convocatoria012,
  n30,
  n31,
  convocatoria013,
  n32,
  n33,
  n34,
  n35,
  convocatoria014,
  n36,
  n37,
  n38,
  n39,
  n40,
  n41,
  n42,
  n43,
  n44,
  n45,
  n46,
  n47,
  n48,
  n49,
  n50,
} from "../../json/anioLicitaciones/2025/anioLicitacion2025";

export const obtenerDatosSeleccionados = (selectedItemIndex) => {
  let datosSeleccionados = [];

  switch (selectedItemIndex) {
    case "CONVOCATORIA 01-2025":
      datosSeleccionados = convocatoria001;
      break;
    case "EA-913005999-N1-2025":
      datosSeleccionados = n1;
      break;
    case "EA-913005999-N2-2025":
      datosSeleccionados = n2;
      break;
    case "CONVOCATORIA 01-2025 OBRA":
      datosSeleccionados = convocatoriaLOP1;
      break;
    case "CAASIM-HGO-L.O.P.-01-2025":
      datosSeleccionados = lop1;
      break;
    case "CONVOCATORIA 02-2025":
      datosSeleccionados = convocatoria002;
      break;
    case "EA-913005999-N3-2025":
      datosSeleccionados = n3;
      break;
    case "EA-913005999-N4-2025":
      datosSeleccionados = n4;
      break;
    case "EA-913005999-N5-2025":
      datosSeleccionados = n5;
      break;
    case "EA-913005999-N6-2025":
      datosSeleccionados = n6;
      break;
    case "EA-913005999-N7-2025":
      datosSeleccionados = n7;
      break;
    case "CONVOCATORIA 03-2025":
      datosSeleccionados = convocatoria003;
      break;
    case "EA-913005999-N8-2025":
      datosSeleccionados = n8;
      break;
    case "EA-913005999-N9-2025":
      datosSeleccionados = n9;
      break;
    case "CONVOCATORIA 04-2025":
      datosSeleccionados = convocatoria004;
      break;
    case "EA-913005999-N10-2025":
      datosSeleccionados = n10;
      break;
    case "CONVOCATORIA 05-2025":
      datosSeleccionados = convocatoria005;
      break;
    case "EA-913005999-N11-2025":
      datosSeleccionados = n11;
      break;
    case "EA-913005999-N12-2025":
      datosSeleccionados = n12;
      break;
    case "EA-913005999-N13-2025":
      datosSeleccionados = n13;
      break;
    case "EA-913005999-N14-2025":
      datosSeleccionados = n14;
      break;
    case "CONVOCATORIA 02-2025 OBRA":
      datosSeleccionados = convocatoriaLOP2;
      break;
    case "CAASIM-HGO-L.O.P.-02-2025":
      datosSeleccionados = lop2;
      break;
    case "CONVOCATORIA 03-2025 OBRA":
      datosSeleccionados = convocatoriaLOP3;
      break;
    case "CAASIM-HGO-L.O.P.-03-2025":
      datosSeleccionados = lop3;
      break;
    case "CONVOCATORIA 06-2025":
      datosSeleccionados = convocatoria006;
      break;
    case "EA-913005999-N15-2025":
      datosSeleccionados = n15;
      break;
    case "EA-913005999-N16-2025":
      datosSeleccionados = n16;
      break;
    case "EA-913005999-N17-2025":
      datosSeleccionados = n17;
      break;
    case "EA-913005999-N18-2025":
      datosSeleccionados = n18;
      break;
    case "CONVOCATORIA 04-2025 OBRA":
      datosSeleccionados = convocatoriaLOP4;
      break;
    case "CAASIM-HGO-L.O.P.-04-2025":
      datosSeleccionados = lop4;
      break;
    case "CONVOCATORIA 07-2025":
      datosSeleccionados = convocatoria007;
      break;
    case "EA-913005999-N19-2025":
      datosSeleccionados = n19;
      break;
    case "EA-913005999-N20-2025":
      datosSeleccionados = n20;
      break;
    case "EA-913005999-N21-2025":
      datosSeleccionados = n21;
      break;
    case "CONVOCATORIA 08-2025":
      datosSeleccionados = convocatoria008;
      break;
    case "EA-913005999-N22-2025":
      datosSeleccionados = n22;
      break;
    case "EA-913005999-N23-2025":
      datosSeleccionados = n23;
      break;
    case "EA-913005999-N24-2025":
      datosSeleccionados = n24;
      break;
    case "CONVOCATORIA MULTIPLE 05-2025":
      datosSeleccionados = convocatoriaMult05;
      break;
    case "CAASIM-HGO-L.O.P.-05-2025":
      datosSeleccionados = lop5;
      break;
    case "CAASIM-HGO-L.O.P.-06-2025":
      datosSeleccionados = lop6;
      break;
    case "CONVOCATORIA 09-2025":
      datosSeleccionados = convocatoria009;
      break;
    case "EA-913005999-N25-2025":
      datosSeleccionados = n25;
      break;
    case "CONVOCATORIA 10-2025":
      datosSeleccionados = convocatoria010;
      break;
    case "EA-913005999-N26-2025":
      datosSeleccionados = n26;
      break;
    case "CONVOCATORIA 11-2025":
      datosSeleccionados = convocatoria011;
      break;
    case "EA-913005999-N27-2025":
      datosSeleccionados = n27;
      break;
    case "EA-913005999-N28-2025":
      datosSeleccionados = n28;
      break;
    case "EA-913005999-N29-2025":
      datosSeleccionados = n29;
      break;
    case "CONVOCATORIA 12-2025":
      datosSeleccionados = convocatoria012;
      break;
    case "EA-913005999-N30-2025":
      datosSeleccionados = n30;
      break;
    case "EA-913005999-N31-2025":
      datosSeleccionados = n31;
      break;
    case "CONVOCATORIA 13-2025":
      datosSeleccionados = convocatoria013;
      break;
    case "EA-913005999-N32-2025":
      datosSeleccionados = n32;
      break;
    case "EA-913005999-N33-2025":
      datosSeleccionados = n33;
      break;
    case "EA-913005999-N34-2025":
      datosSeleccionados = n34;
      break;
    case "EA-913005999-N35-2025":
      datosSeleccionados = n35;
      break;
    case "CONVOCATORIA 14-2025":
      datosSeleccionados = convocatoria014;
      break;
    case "EA-913005999-N36-2025":
      datosSeleccionados = n36;
      break;
    case "EA-913005999-N37-2025":
      datosSeleccionados = n37;
      break;
    case "EA-913005999-N38-2025":
      datosSeleccionados = n38;
      break;
    case "EA-913005999-N39-2025":
      datosSeleccionados = n39;
      break;
    case "EA-913005999-N40-2025":
      datosSeleccionados = n40;
      break;
    case "EA-913005999-N41-2025":
      datosSeleccionados = n41;
      break;
    case "EA-913005999-N42-2025":
      datosSeleccionados = n42;
      break;
    case "EA-913005999-N43-2025":
      datosSeleccionados = n43;
      break;
    case "EA-913005999-N44-2025":
      datosSeleccionados = n44;
      break;
    case "EA-913005999-N45-2025":
      datosSeleccionados = n45;
      break;
    case "EA-913005999-N46-2025":
      datosSeleccionados = n46;
      break;
    case "EA-913005999-N47-2025":
      datosSeleccionados = n47;
      break;
    case "EA-913005999-N48-2025":
      datosSeleccionados = n48;
      break;
    case "EA-913005999-N49-2025":
      datosSeleccionados = n49;
      break;
    case "EA-913005999-N50-2025":
      datosSeleccionados = n50;
      break;

    default:
      datosSeleccionados = [];
  }

  return datosSeleccionados;
};
